module.exports = __webpack_public_path__ + "static/media/1-oz-gold-american-eagle.d3cce53f.png";